import { usePasteConfig } from '@/components/custom/erp/input-table-v2';

interface UseDetailPasteProps {
  columns: BanHangRecord[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<BanHangRecord[]>; resultField?: string }>
  ) => void;
}

export const useDetailPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseDetailPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
